import React, {Component} from 'react';
import {connect} from 'react-redux';
import ApiActions from 'go/actions/api';
import {Segment} from 'semantic-ui-react';
import TopLevel from './TopLevel';
import _ from 'lodash';
import REST from 'go/requests/rest';
import {API_SUBGRANT_GET_SUCCESS} from 'common/types';
import SideNavInternal from 'go/components/dynamic/layout/SideNavInternal';
import {isFemaUser} from 'common/utils';

const defaultActive = 'SubGrant';
const subgrant = {
  itemName: 'subGrant',
  label: 'Subgrant',
};
export class SubGrantNavItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checking: true,
      shouldLoad: false,
      hasBeenExpanded: false,
      activeSubPage: defaultActive,
      config: null,
      subItems: [subgrant],
    };
  }

  componentDidMount() {
    let {token, grantId, subGrantId} = this.props;
    this.props
      .getSubGrant(token, grantId, subGrantId)
      .then(async (res) => {
        if (res.type === API_SUBGRANT_GET_SUCCESS) {
          const subGrantFoId = _.get(res, 'payload.fundingOpportunityId');
          const subGrantStatus = _.get(res, 'payload.status');
          const statusList = ["subAwardOffered", "subgrantFinancialReconciliation", "closed", "subAwardDeclined", "subAwardRescinded", "closeoutInitiated", "subAwardOfferExpired", "subAwardAccepted"];
          await REST.fundingOpportunity
          .getFundingOpportunity(token, subGrantFoId).then(res => res.json())
          .then(foData => {
            const configPath = _.get(foData, 'configPath', null);
            if (statusList.includes(subGrantStatus) && configPath === 'passthrough/0') {
              this.setState({
                shouldLoad: true,
              });
            }
          });
        }
        this.setState({
          checking: false,
        });
      })
      .catch((err) => {
        console.log(
          `Subgrant could not be retrieved for subGrantId: ${subGrantId}.`
        );
        this.setState({
          checking: false,
        });
      });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isActive !== this.props.isActive) {
      this.setState({
        hasBeenExpanded: true,
      });
    }
  }

  setActivePage(configName) {
    // subGrant
    this.props.loadPageWithConfig(configName).then((config) => {
      this.setState({
        activeSubPage: configName,
        config: config,
      });
    });
  }

  render() {
    const {baseClass, isActive, config} = this.props;
    const SubGrantName = 'Subgrant';
    const activePage = 'subGrant';
    if (this.state.checking) {
      return (
        <Segment tertiary inverted>
          Checking for SubGrant...
        </Segment>
      );
    } else if (this.state.shouldLoad) {
      return (
        <React.Fragment>
          <TopLevel
            name={SubGrantName}
            baseClass={baseClass}
            handleClick={() => this.setActivePage(activePage)}
            active={isActive}
            isExpandable={false}
          />
          {isActive && config && (
            <React.Fragment>
              <SideNavInternal
                navToSpecificLocation={() => {
                  /* this is the key to making the sidenav active state work
                          don't use until figuring out how to incorporate VisibilitySensor into this
                        */
                }}
                location={this.props.location}
                title={SubGrantName + ' navigation'}
                startingIndentLevel={1}
                {...config.payload}
              />
            </React.Fragment>
          )}
        </React.Fragment>
      );
    } else {
      return <React.Fragment />;
    }
  }
}

export const mapDispatchToProps = (dispatch) => ({
  getSubGrant: (token, grantId, subGrantId) => {
    const action = ApiActions.subGrant.getSubGrant(
      token,
      grantId,
      subGrantId
    );
    const res = dispatch(action);
    return res;
  },
});

export const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubGrantNavItem);
